import React from 'react';
import { chakra } from '@chakra-ui/react';
import { TRANSITION_BG } from '@/components/ui/motion.ts';

interface DropdownOptionProps {
	selected: boolean;
	onClick: () => void;
	children: React.ReactNode;
}

/** A selectable row inside a DropdownMenu — fills its background on hover and while selected. */
const DropdownOption: React.FC<DropdownOptionProps> = ({ selected, onClick, children }) => {
	return (
		<chakra.button
			type="button"
			display="block"
			w="full"
			py={3}
			px={4}
			textStyle="body.sm"
			fontWeight={selected ? 600 : 400}
			border="none"
			bg={selected ? 'surface.subtle' : 'transparent'}
			cursor="pointer"
			textAlign="left"
			transition={TRANSITION_BG}
			_hover={{ bg: 'surface.subtle' }}
			onClick={onClick}
		>
			{children}
		</chakra.button>
	);
};

export default DropdownOption;
